import { HttpClient } from '@angular/common/http'
import { CoreEnvironmentService } from './core-environment.service'
import { UtilsService } from './utils.service'

export class BaseApiService {
  constructor(
    public http: HttpClient,
    public environment: CoreEnvironmentService,
    public utilsService: UtilsService
  ) {}

  public makeRequest(type: 'GET' | 'POST' | 'DELETE' | 'PUT', url: string, data: object): Promise<any> {
    const baseUrl = this.environment.getBaseURL() + url
    const queryParams = this.utilsService.transformObjInQueryParams(data)
    if (type === 'GET') {
      return this.http.get(`${baseUrl}?${queryParams}`).toPromise()
    } else if (type === 'POST') {
      return this.http.post(baseUrl, data).toPromise()
    } else if (type === 'PUT') {
      return this.http.put(baseUrl, data).toPromise()
    } else if (type === 'DELETE') {
      return this.http.delete(baseUrl, data).toPromise()
    }
  }
}
